import React from "react"
import styled from "styled-components"

import { color, thumbnailSize } from "~/libs/style"

type ThumbnailProps = {
  src: string
  className?: string
  width?: number
  height?: number
}

const imageOnLoadHandler = (e: React.SyntheticEvent<HTMLImageElement>) => {
  e.currentTarget.style.backgroundColor = color.white // 背景透過サムネイルのために変更
}

export const ThumbnailNew: React.FC<ThumbnailProps> = ({ src, className, width, height }) => {
  return (
    <Img
      className={className}
      src={src}
      width={`${width ?? thumbnailSize}px`}
      height={`${height ?? thumbnailSize}px`}
      alt=""
      loading="lazy"
      onLoad={imageOnLoadHandler}
    />
  )
}

const Img = styled.img`
  position: relative;
`
